<script setup lang="ts">
import { watchEffect, ref } from "vue";
import { atomReadStyle, atomWriteStyle } from "@zyzgroup/core-web";

// for merge ce shadow-root styles
defineOptions({
  customOptions: {},
  inheritAttrs: true
});

const props = withDefaults(
  defineProps<{
    global?: boolean;
    opacity?: number;
  }>(),
  {
    global: true,
    opacity: 0.6
  }
);

const emits = defineEmits<{
  (event: "open"): void;
  (event: "close"): void;
}>();

const el = ref();

const color = `rgba(0, 0, 0, ${props.opacity})`;

const visible = ref(false);

// fixScroll
let initParentOverflow = "";
if (props.global) {
  initParentOverflow =
    atomReadStyle(document.documentElement, "overflow") || "visible";
} else {
  watchEffect(() => {
    if (!el.value || initParentOverflow) {
      // not mounted yet, or the element was unmounted (e.g. by v-if)
      return;
    }
    initParentOverflow =
      atomReadStyle(el.value.parentElement, "overflow") || "visible";
  });
}

function setParentOverflow() {
  atomWriteStyle(
    props.global ? document.documentElement : el.value.parentElement,
    "overflow",
    visible.value ? "hidden" : initParentOverflow || "visible"
  );
}

function open() {
  visible.value = true;
  setParentOverflow();
  emits("open");
}

function close() {
  visible.value = false;
  setParentOverflow();
  emits("close");
}

defineExpose({ open, close });
</script>

<template>
  <!-- FOUC: flash of unstyled content 未样式化文本闪烁 -->
  <!-- v-if="visible"使子元素重新创建 或 子元素传不同 key 会重新创建 -->
  <!-- display: visible ? 'block' : 'none', 子元素不会重新创建 -->
  <div
    ref="el"
    class="overlay"
    v-if="visible"
    :style="{
      display: 'block',
      position: 'fixed',
      width: '100%',
      height: '100%',
      'z-index': '99999',
      inset: '0',
      'background-color': color,
      overflow: 'hidden',
      'overscroll-behavior-y': 'contain', // avoid scroll chaining
      'scrollbar-gutter': 'stable'
    }"
  >
    <slot></slot>
  </div>
</template>
